export const accountType = [
	{id: 1, label: 'Significant Account'},
	{id: 2, label: 'Limited Risk Account'},
	{id: 3, label: 'Insignificant Account'},
	{id: 4, label: 'Account - Other'},
	{id: 5, label: 'Significant Disclosure'}
];

export const inherentRiskType = [
	{id: 1, label: 'Higher'},
	{id: 2, label: 'Lower'},
	{id: 3, label: 'Very Low'}
];

export const controlRiskType = [
	{id: 1, label: 'Rely'},
	{id: 2, label: 'Not Rely'},
	{id: 3, label: 'Test MP'}
];

export const riskType = [
	{id: 1, label: 'Significant Risk'},
	{id: 2, label: 'Fraud Risk'},
	{id: 3, label: 'Inherent Risk'}
];

export const taskStatus = [
	{id: 1, label: 'Open'},
	{id: 2, label: 'In Progress'},
	{id: 3, label: 'In Review'},
	{id: 4, label: 'Complete'},
	{id: 5, label: 'Removed'}
];
